import { AxiosResponse } from 'axios';
import { SET_FOLDERS, SET_FOLDER, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_FOLDER_ISLOADING,
  DELETE_FOLDER,
  EDIT_FOLDER,
  GET_FOLDERS,
  REGISTER_FOLDER,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Folder from '@/services/folder';
import { Module } from 'vuex';
import { EditFolder, RegisterFolder, GetFolder } from '@/dtos/folder.dto';

const buildPaginationMeta = (metaData: any, payload: any) => {
  const perPage = Number(metaData?.perPage ?? payload?.limit ?? 100);
  const currentPage = Number(metaData?.currentPage ?? payload?.page ?? 1);
  const totalRecords = Number(metaData?.totalRecords ?? 0);
  const totalPages = Number(metaData?.totalPages ?? Math.max(Math.ceil(totalRecords / perPage), 1));

  return { currentPage, perPage, totalRecords, totalPages };
};

const folder: Module<any, {}> = {
  state: {
    folder: {
      data: null,
      isLoading: false,
      mataData: null
    },
    folders: {
      data: null,
      metaData: null,
      isLoading: false,
    },
  },
  getters: {
    folder: (state: { folder: any }) => state.folder,
    folders: (state: { folders: any }) => state.folders,
  },
  mutations: {
    [SET_FOLDER]: (
      state: { folder: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.folder.data = payload.data) : null,
        (state.folder.isLoading = payload.isLoading);
    },
    [SET_FOLDERS]: (
      state: { folders: StateObject },
      payload: { data: null; metaData?: any; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.folders.data = payload.data) : null,
        payload.metaData != null ? (state.folders.metaData = payload.metaData) : null,
        (state.folders.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_FOLDER]: async ({ commit }: any, payload: any) => {
      commit(SET_FOLDER, { data: null, isLoading: true });

      const result: AxiosResponse = await Folder.registerFolder(
        payload as RegisterFolder
      );

      if (result) {
        if (result.data.status) {
          commit(SET_FOLDER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_FOLDER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_FOLDER, { isLoading: false });
        return false;
      }
    },
    [GET_FOLDERS]: async ({ commit }: any, payload: any) => {
      commit(SET_FOLDERS, { data: null, isLoading: true });

      const result: AxiosResponse = await Folder.getFolders(
        payload as GetFolder
      );

      if (result) {
        if (result.data.status) {
          const records = Array.isArray(result.data.data) ? result.data.data : [];
          const metaData = buildPaginationMeta(result.data.metaData, payload);
          commit(SET_FOLDERS, { data: records, metaData, isLoading: false });
          return true;
        }
        commit(SET_FOLDERS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_FOLDERS, { isLoading: false });
        return false;
      }
    },
    [EDIT_FOLDER]: async ({ commit }: any, payload: any) => {
      commit(SET_FOLDER, { data: null, isLoading: true });

      const result: AxiosResponse = await Folder.editFolder(
        payload as EditFolder
      );

      if (result) {
        if (result.data.status) {
          commit(SET_FOLDER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_FOLDER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_FOLDER, { isLoading: false });
        return false;
      }
    },
    [DELETE_FOLDER]: async ({ commit }: any, payload: string) => {
      commit(SET_FOLDER, { data: null, isLoading: true });

      const result: AxiosResponse = await Folder.deleteFolder(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_FOLDER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_FOLDER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_FOLDER, { isLoading: false });
        return false;
      }
    },
    [CLEAR_FOLDER_ISLOADING]: ({ commit }) => {
      commit(SET_FOLDER, { isLoading: false });
      commit(SET_FOLDERS, { isLoading: false });
    },
  },
};

export default folder;
